import React from "react";
import { Attachment } from "./Attachment";
import entries from "lodash/entries";
export var Attachments = function (_a) {
    var item = _a.item;
    var attachments = entries(item.attachment_urls).map(function (_a) {
        var key = _a[0], url = _a[1];
        var type = key.endsWith("pdf") ? "pdf" : "attachment";
        return (React.createElement(Attachment, { key: key, type: type, url: url, name: key }));
    });
    return React.createElement(React.Fragment, null, attachments);
};
